export default "__VITE_ASSET__eXBNCwjG__"